module.exports = __webpack_public_path__ + "static/media/ic-delete.783a67be.svg";